import React from 'react';
import PropTypes from 'prop-types';

/**
 * Material Design "AutoAwesome" glyph.
 * @material-ui/icons v4 does not ship AutoAwesome, so we inline the official path.
 * Decorative by default (aria-hidden). Pass titleAccess to expose an accessible name.
 */
export default function SparklesIcon({ className, style, size = 18, color = 'currentColor', titleAccess, ...rest }) {
  const isLabeled = Boolean(titleAccess);

  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden={isLabeled ? undefined : true}
      aria-label={isLabeled ? titleAccess : undefined}
      {...rest}
      data-testid="sparkles-icon"
    >
      {isLabeled ? <title>{titleAccess}</title> : null}
      <path
        fill={color}
        d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"
      />
    </svg>
  );
}

SparklesIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.number,
  color: PropTypes.string,
  titleAccess: PropTypes.string,
};
